<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part"><a id="page1"></a><img alt="" src="OEBPS/images/Wilc_9780312322496_epub_L02_r1.png"/> <em>PART ONE</em></h1>
<h1 class="subchapter">ORIGINS</h1>
<div class="block">
<p class="nonindent">“I’d hang on the fence at the end of the runway and watch as the big Ford trimotors came over at fifty feet in the air.”</p>
<p class="right">—<em>Butch Voris</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_p01_r1.vue?85098780